import translate from "@/i18n/translate";
import { Institution } from "../common/interfaces/Interface";
export interface OrganizationInsightsProps {
  noDataFound?: boolean;
}
export default function OrganizationInsights({
  noDataFound
}: OrganizationInsightsProps) {
  return (
    <div>
      <div className="page-banner -insights-header insights-header-home">
        <h2 className="titles">Insights</h2>

        {noDataFound ? (
          <div className="description">
            {translate("app.studentLearningAssessment.welcome")}
          </div>
        ) : (
          <div className="description">
            {translate("app.insight.insightProgramDesc")}
          </div>
        )}
      </div>
    </div>
  );
}
